interface Props {
  [name: string]: {
    dataStartArr: number[];
    pageBreakArr: number[];
    pageBreakSbmArr?: number[];
    // template_id는 측정값 id, 배열의 숫자 [row, col]
    // row는 dataStartArr에서 엑셀의 측정값 입력 부분 row 뺀 값
    // 나중에 dataStartArr만 바뀌어도 자동으로 바뀌게 하기 위해서 그렇게 함
    calculateInfoArr?: {
      [template_id: string]: number[];
    }[];
    dataInspectionArr?: number[];
    dataSbmStartArr?: number[];
  };
}

// 24.03.26 엑셀 사진 6개 부분
export const rowStartNumTemplateImg6: Props = {
  냉각탑: {
    dataStartArr: [49, 79, 107, 134, 160, 195, 220, 249, 280, 305],
    dataInspectionArr: [42, 68,  98, 126, 153, 179, 214, 243, 272, 299],
    pageBreakArr: [40, 66, 96, 124, 151, 177, 212, 241, 270, 297],
    pageBreakSbmArr: [41, 67, 97, 125, 152, 178, 213, 242, 271, 298],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 4],
        'COP/측정값': [20, 7],
        '상태': [20, 10],
      },
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 4],
        'COP/측정값': [20, 7],
        '상태': [20, 10],
      },
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 4],
        'COP/측정값': [20, 7],
        '상태': [20, 10],
      },
    ],
  },
  냉동기: {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  // 냉동기 subtypes (clone from 냉동기, will update when custom templates ready)
  터보냉동기: {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  스크류냉동기: {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  '흡수식냉동기(증기)': {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  '흡수식냉동기(중온수)': {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP/설계값': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  직화식냉온수기: {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        'COP_HHV/설계값': [20, 5],
        'COP_HHV/측정값': [20, 9],
      },
    ],
  },
  '흡수식냉온수기(난방)': {
    dataStartArr: [45, 88, 112, 137, 164, 191, 218],
    dataInspectionArr: [38, 64, 107, 131, 156, 183, 210],
    pageBreakArr: [37, 63, 106, 130, 155, 182, 209],
    pageBreakSbmArr: [37, 63, 106, 130, 155, 182, 209],
  },
  축열조: {
    dataStartArr: [45, 70, 98, 123, 148, 176, 203],
    dataInspectionArr: [38, 64, 89, 117, 142, 171, 195],
    pageBreakArr: [36, 62, 87, 115, 140, 169, 193],
    pageBreakSbmArr: [37, 63, 88, 116, 141, 170, 194],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        '적정 비율': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  보일러: {
    dataStartArr: [49, 77, 104, 136, 163, 189, 218, 261, 289, 316, 343],
    dataInspectionArr: [42, 68, 96, 123, 155, 182, 208, 237, 280, 308, 335],
    pageBreakArr: [40, 66, 94, 121, 153, 180, 206, 235, 278, 306, 333],
    pageBreakSbmArr: [41, 67, 95, 122, 154, 181, 207, 236, 279, 307, 334],
  },
  '캐스케이드 보일러': {
    dataStartArr: [47, 75, 102, 129, 155, 183, 226, 254, 281],
    dataInspectionArr: [40, 66, 94, 121, 148, 174, 202, 245, 273],
    pageBreakArr: [39, 65, 93, 120, 147, 173, 201, 244, 272],
    pageBreakSbmArr: [39, 65, 93, 120, 147, 173, 201, 244, 272],
  },
  열교환기: {
    dataStartArr: [44, 72, 103, 134, 159, 185],
    dataInspectionArr: [37, 63, 91, 128, 153, 178],
    pageBreakArr: [35, 61, 89, 126, 151, 176],
    pageBreakSbmArr: [36, 62, 90, 127, 152, 177],
    calculateInfoArr: [
      {
        '1차측(중온수)/입구': [20, 4],
        '1차측(중온수)/출구': [20, 7],
        '1차측(중온수)/ΔP': [20, 10],
        '2차측(온수)/입구': [22, 4],
        '2차측(온수)/출구': [22, 7],
        '2차측(온수)/ΔP': [22, 10],
      },
    ],
  },
  팽창탱크: {
    dataStartArr: [42, 67, 92, 125],
    dataInspectionArr: [35, 61, 86, 115],
    pageBreakArr: [33, 59, 84, 113],
    pageBreakSbmArr: [34, 60, 85, 114],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        '적정 압력값': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  '펌프(냉·난방)': {
    dataStartArr: [46, 72, 115, 148, 174, 200, 231],
    dataInspectionArr: [39, 65, 91, 134, 167, 193, 223],
    pageBreakArr: [37, 63, 89, 132, 165, 191, 221],
    pageBreakSbmArr: [38, 64, 90, 133, 166, 192, 222],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        '적정값': [20, 5],
        '세팅값': [20, 9],
      },
      {
        '유량/설계값': [20, 4],
        '유량/측정값': [20, 7],
        '유량/상태': [20, 10],
        '양정/설계값': [22, 4],
        '양정/측정값': [22, 7],
        '양정/상태': [22, 10],
        '동력/설계값': [24, 4],
        '동력/측정값': [24, 7],
        '동력/상태': [24, 10],
      },
    ],
  },
  '신재생(지열)': {
    dataStartArr: [40, 68, 94],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '신재생(태양열)': {
    dataStartArr: [40, 68, 93],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '신재생(연료전지)': {
    dataStartArr: [40, 68, 93],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '신재생(대기열)': {
    dataStartArr: [40, 68, 94],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '패키지 에어컨': {
    dataStartArr: [44, 69, 95, 120, 145],
    dataInspectionArr: [37, 63, 88, 114, 139],
    pageBreakArr: [35, 61, 86, 112, 137],
    pageBreakSbmArr: [36, 62, 87, 113, 138],
  },
  항온항습기: {
    dataStartArr: [43, 68, 93, 118, 143],
    dataInspectionArr: [36, 62, 87, 112, 137],
    pageBreakArr: [34, 60, 85, 110, 135],
    pageBreakSbmArr: [35, 61, 86, 111, 136],
  },
  공기조화기: {
    dataStartArr: [46, 72, 98, 123, 148, 191, 216, 242],
    dataInspectionArr: [39, 65, 91, 117, 142, 183, 210, 235],
    pageBreakArr: [37, 63, 89, 115, 140, 181, 208, 233],
    pageBreakSbmArr: [38, 64, 90, 116, 141, 182, 209, 234],
    calculateInfoArr: [
      {
        '급기/풍량/설계값': [20, 4],
        '급기/풍량/측정값': [20, 7],
        '급기/풍량/상태': [20, 10],
        '급기/동력/설계값': [22, 4],
        '급기/동력/측정값': [22, 7],
        '급기/동력/상태': [22, 10],
        '급기/정압/설계값': [24, 4],
        '급기/정압/측정값': [24, 7],
        '급기/정압/상태': [24, 10],
        '환기/풍량/설계값': [28, 4],
        '환기/풍량/측정값': [28, 7],
        '환기/풍량/상태': [28, 10],
        '환기/동력/설계값': [30, 4],
        '환기/동력/측정값': [30, 7],
        '환기/동력/상태': [30, 10],
        '환기/정압/설계값': [32, 4],
        '환기/정압/측정값': [32, 7],
        '환기/정압/상태': [32, 10],
      },
      {
        '장비번호': [20, 1],
        '적정 압력상태': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  팬코일유닛: {
    dataStartArr: [45, 73, 98, 123, 148, 174],
    dataInspectionArr: [38, 64, 92, 117, 142, 167],
    pageBreakArr: [36, 62, 90, 115, 140, 165],
    pageBreakSbmArr: [37, 63, 91, 116, 141, 166],
  },
  환기설비: {
    dataStartArr: [46, 75, 100, 126, 152, 178, 211],
    dataInspectionArr: [39, 65, 94, 119, 145, 171, 205],
    pageBreakArr: [37, 63, 92, 117, 143, 169, 203],
    pageBreakSbmArr: [38, 64, 93, 118, 144, 170, 204],
    calculateInfoArr: [
      {
        '풍량/설계값': [20, 4],
        '풍량/측정값': [20, 7],
        '풍량/상태': [20, 10],
        '동력/설계값': [22, 4],
        '동력/측정값': [22, 7],
        '동력/상태': [22, 10],
        '정압/설계값': [24, 4],
        '정압/측정값': [24, 7],
        '정압/상태': [24, 10],
      },
    ],
  },
  필터: {
    dataStartArr: [41, 66, 96],
    dataInspectionArr: [34, 60, 89],
    pageBreakArr: [32, 58, 87],
    pageBreakSbmArr: [33, 59, 88],
    calculateInfoArr: [
      {
        '장비번호': [20, 1],
        '적정 압력상태': [20, 5],
        'COP/측정값': [20, 9],
      },
    ],
  },
  위생기구설비: {
    dataStartArr: [41, 69, 100, 125],
    dataInspectionArr: [34, 60, 94, 119],
    pageBreakArr: [32, 58, 92, 117],
    pageBreakSbmArr: [33, 59, 93, 118],
    calculateInfoArr: [
      {
        '최상층/최저필요수압': [20, 5],
        '최상층/측정값': [20, 9],
        '최하층/최저필요수압': [22, 5],
        '최하층/측정값': [22, 9],
      },
    ],
  },
  '급수·급탕설비': {
    dataStartArr: [41, 68, 93, 119],
    dataInspectionArr: [34, 60, 87, 112],
    pageBreakArr: [32, 58, 85, 110],
    pageBreakSbmArr: [33, 59, 86, 111],
  },
  '고·저수조': {
    dataStartArr: [41, 67, 93, 130],
    dataInspectionArr: [34, 60, 86, 112],
    pageBreakArr: [32, 58, 84, 110],
    pageBreakSbmArr: [33, 59, 85, 111],
  },
  '오·배수 통기 및 우수배수설비': {
    dataStartArr: [42, 70, 95, 121, 146],
    dataInspectionArr: [35, 61, 89, 114, 140],
    pageBreakArr: [33, 59, 87, 112, 138],
    pageBreakSbmArr: [34, 60, 88, 113, 139],
  },
  오수정화설비: {
    dataStartArr: [41, 68, 93, 118],
    dataInspectionArr: [34, 60, 87, 112],
    pageBreakArr: [32, 58, 85, 110],
    pageBreakSbmArr: [33, 59, 86, 111],
  },
  '물 재이용설비': {
    dataStartArr: [43, 68, 93, 119, 144, 168],
    dataInspectionArr: [36, 62, 87, 112, 138, 163],
    pageBreakArr: [34, 60, 85, 110, 136, 161],
    pageBreakSbmArr: [35, 61, 86, 111, 137, 162],
  },
  배관설비: {
    dataStartArr: [41, 67, 110, 136],
    dataInspectionArr: [34, 60, 86, 129],
    pageBreakArr: [32, 58, 84, 127],
    pageBreakSbmArr: [33, 59, 85, 128],
  },
  덕트설비: {
    dataStartArr: [40, 68, 96],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  보온설비: {
    dataStartArr: [42, 67, 92, 118, 146],
    dataInspectionArr: [35, 61, 86, 111, 137],
    pageBreakArr: [33, 59, 84, 109, 135],
    pageBreakSbmArr: [34, 60, 85, 110, 136],
  },
  자동제어설비: {
    dataStartArr: [45, 70, 95, 120, 146, 172, 198],
    dataInspectionArr: [38, 64, 89, 114, 139, 165, 191],
    pageBreakArr: [36, 62, 87, 112, 137, 163, 189],
    pageBreakSbmArr: [37, 63, 88, 113, 138, 164, 190],
  },
  '방음·방진·내진설비': {
    dataStartArr: [40, 70, 98],
    dataInspectionArr: [33, 59, 89],
    pageBreakArr: [31, 57, 87],
    pageBreakSbmArr: [32, 58, 88],
  },
};

// 24.03.26 엑셀 사진 3개 부분
export const rowStartNumTemplateImg3: Props = {
  냉각탑: {
    dataStartArr: [49, 71, 91, 110, 128, 155, 172, 193, 216, 233],
    dataInspectionArr: [42, 60, 82, 102, 121, 139, 166, 187, 208, 227],
    pageBreakArr: [40, 80, 119, 137, 164, 206],
    pageBreakSbmArr: [41, 81, 120, 138, 165, 207],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 4],
        'COP/측정값': [12, 7],
        '상태': [12, 10],
      },
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 4],
        'COP/측정값': [12, 7],
        '상태': [12, 10],
      },
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 4],
        'COP/측정값': [12, 7],
        '상태': [12, 10],
      },
    ],
  },
  냉동기: {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  // 냉동기 subtypes (clone from 냉동기, will update when custom templates ready)
  터보냉동기: {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  스크류냉동기: {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  '흡수식냉동기(증기)': {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  '흡수식냉동기(중온수)': {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP/설계값': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  직화식냉온수기: {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        'COP_HHV/설계값': [12, 5],
        'COP_HHV/측정값': [12, 9],
      },
    ],
  },
  '흡수식냉온수기(난방)': {
    dataStartArr: [45, 82, 98, 115, 134, 153, 172],
    dataInspectionArr: [38, 56, 93, 109, 126, 145, 164],
    pageBreakArr: [37, 55, 92, 108, 144],
    pageBreakSbmArr: [37, 55, 92, 108, 144],
  },
  축열조: {
    dataStartArr: [45, 62, 82, 99, 116, 136, 155],
    dataInspectionArr: [38, 56, 73, 93, 110, 131, 147],
    pageBreakArr: [36, 71, 108, 145],
    pageBreakSbmArr: [37, 72, 109, 146],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        '적정 비율': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },

  보일러: {
    dataStartArr: [49, 69, 88, 112, 131, 149, 170, 208, 228, 247, 266],
    dataInspectionArr: [42, 60, 80, 99, 123, 142, 160, 181, 219, 239, 258],
    pageBreakArr: [40, 78, 121, 158, 179, 217, 256],
    pageBreakSbmArr: [41, 79, 122, 159, 180, 218, 257],
  },
  '캐스케이드 보일러': {
    dataStartArr: [47, 67, 86, 105, 123, 143, 181, 201, 220],
    dataInspectionArr: [40, 58, 78, 97, 116, 134, 154, 192, 212],
    pageBreakArr: [39, 77, 115, 153, 191],
    pageBreakSbmArr: [39, 77, 115, 153, 191],
  },
  열교환기: {
    dataStartArr: [44, 64, 87, 110, 127, 145],
    dataInspectionArr: [37, 55, 75, 104, 121, 138],
    pageBreakArr: [35, 73, 102, 136],
    pageBreakSbmArr: [36, 74, 103, 137],
    calculateInfoArr: [
      {
        '1차측(중온수)/입구': [12, 4],
        '1차측(중온수)/출구': [12, 7],
        '1차측(중온수)/ΔP': [12, 10],
        '2차측(온수)/입구': [14, 4],
        '2차측(온수)/출구': [14, 7],
        '2차측(온수)/ΔP': [14, 10],
      },
    ],
  },
  팽창탱크: {
    dataStartArr: [42, 59, 76, 101],
    dataInspectionArr: [35, 53, 70, 91],
    pageBreakArr: [33, 68],
    pageBreakSbmArr: [34, 69],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        '적정 압력값': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  '펌프(냉·난방)': {
    dataStartArr: [46, 64, 107, 132, 150, 168, 191],
    dataSbmStartArr: [46, 64, 104, 128, 146, 164, 187],
    dataInspectionArr: [39, 57, 75, 115, 139, 157, 179],
    pageBreakArr: [37, 73, 116, 159, 181],
    pageBreakSbmArr: [38, 74, 114, 156, 178],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        '적정값': [12, 5],
        '세팅값': [12, 9],
      },
      {
        '유량/설계값': [12, 4],
        '유량/측정값': [12, 7],
        '유량/상태': [12, 10],
        '양정/설계값': [14, 4],
        '양정/측정값': [14, 7],
        '양정/상태': [14, 10],
        '동력/설계값': [16, 4],
        '동력/측정값': [16, 7],
        '동력/상태': [16, 10],
      },
    ],
  },
  '신재생(지열)': {
    dataStartArr: [40, 60, 78],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '신재생(태양열)': {
    dataStartArr: [40, 60, 77],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '신재생(연료전지)': {
    dataStartArr: [40, 60, 77],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '신재생(대기열)': {
    dataStartArr: [40, 60, 78],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '패키지 에어컨': {
    dataStartArr: [44, 61, 79, 96, 113],
    dataInspectionArr: [37, 55, 72, 90, 107],
    pageBreakArr: [35, 70, 105],
    pageBreakSbmArr: [36, 71, 106],
  },
  항온항습기: {
    dataStartArr: [43, 60, 77, 94, 111],
    dataInspectionArr: [36, 54, 71, 88, 105],
    pageBreakArr: [34, 69, 103],
    pageBreakSbmArr: [35, 70, 104],
  },
  공기조화기: {
    dataStartArr: [46, 64, 82, 99, 116, 151, 168, 186],
    dataInspectionArr: [39, 57, 75, 93, 110, 143, 162, 179],
    pageBreakArr: [37, 73, 108, 141, 177],
    pageBreakSbmArr: [38, 74, 109, 142, 178],
    calculateInfoArr: [
      {
        '급기/풍량/설계값': [12, 4],
        '급기/풍량/측정값': [12, 7],
        '급기/풍량/상태': [12, 10],
        '급기/동력/설계값': [14, 4],
        '급기/동력/측정값': [14, 7],
        '급기/동력/상태': [14, 10],
        '급기/정압/설계값': [16, 4],
        '급기/정압/측정값': [16, 7],
        '급기/정압/상태': [16, 10],
        '환기/풍량/설계값': [20, 4],
        '환기/풍량/측정값': [20, 7],
        '환기/풍량/상태': [20, 10],
        '환기/동력/설계값': [22, 4],
        '환기/동력/측정값': [22, 7],
        '환기/동력/상태': [22, 10],
        '환기/정압/설계값': [24, 4],
        '환기/정압/측정값': [24, 7],
        '환기/정압/상태': [24, 10],
      },
      {
        '장비번호': [12, 1],
        '적정 압력상태': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  팬코일유닛: {
    dataStartArr: [45, 65, 82, 99, 116, 134],
    dataInspectionArr: [38, 56, 76, 93, 110, 127],
    pageBreakArr: [36, 74, 108],
    pageBreakSbmArr: [37, 75, 109],
  },
  환기설비: {
    dataStartArr: [46, 67, 84, 102, 120, 138, 163],
    dataInspectionArr: [39, 57, 78, 95, 113, 131, 157],
    pageBreakArr: [37, 76, 111, 129, 155],
    pageBreakSbmArr: [38, 77, 112, 130, 156],
    calculateInfoArr: [
      {
        '풍량/설계값': [12, 4],
        '풍량/측정값': [12, 7],
        '풍량/상태': [12, 10],
        '동력/설계값': [14, 4],
        '동력/측정값': [14, 7],
        '동력/상태': [14, 10],
        '정압/설계값': [16, 4],
        '정압/측정값': [16, 7],
        '정압/상태': [16, 10],
      },
    ],
  },
  필터: {
    dataStartArr: [41, 58, 80],
    dataInspectionArr: [34, 52, 73],
    pageBreakArr: [32, 71],
    pageBreakSbmArr: [33, 72],
    calculateInfoArr: [
      {
        '장비번호': [12, 1],
        '적정 압력상태': [12, 5],
        'COP/측정값': [12, 9],
      },
    ],
  },
  위생기구설비: {
    dataStartArr: [41, 61, 84, 101],
    dataInspectionArr: [34, 52, 78, 95],
    pageBreakArr: [32, 50, 76],
    pageBreakSbmArr: [33, 51, 77],
    calculateInfoArr: [
      {
        '최상층/최저필요수압': [12, 5],
        '최상층/측정값': [12, 9],
        '최하층/최저필요수압': [14, 5],
        '최하층/측정값': [14, 9],
      },
    ],
  },
  '급수·급탕설비': {
    dataStartArr: [41, 60, 77, 95],
    dataInspectionArr: [34, 52, 71, 88],
    pageBreakArr: [32, 69],
    pageBreakSbmArr: [33, 70],
  },
  '고·저수조': {
    dataStartArr: [41, 59, 77, 106],
    dataInspectionArr: [34, 52, 70, 88],
    pageBreakArr: [32, 68, 86],
    pageBreakSbmArr: [33, 69, 87],
  },
  '오·배수 통기 및 우수배수설비': {
    dataStartArr: [42, 62, 79, 97, 114],
    dataInspectionArr: [35, 53, 73, 90, 108],
    pageBreakArr: [33, 71, 106],
    pageBreakSbmArr: [34, 72, 107],
  },
  오수정화설비: {
    dataStartArr: [41, 60, 77, 94],
    dataInspectionArr: [34, 52, 71, 88],
    pageBreakArr: [32, 69],
    pageBreakSbmArr: [33, 70],
  },
  '물 재이용설비': {
    dataStartArr: [43, 60, 77, 95, 112, 128],
    dataInspectionArr: [36, 54, 71, 88, 106, 123],
    pageBreakArr: [34, 69, 104],
    pageBreakSbmArr: [35, 70, 105],
  },
  배관설비: {
    dataStartArr: [41, 59, 101, 119],
    dataInspectionArr: [34, 52, 70, 112],
    pageBreakArr: [32, 68, 110],
    pageBreakSbmArr: [33, 69, 111],
  },
  덕트설비: {
    dataStartArr: [40, 60, 80],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  보온설비: {
    dataStartArr: [42, 59, 76, 94, 114],
    dataInspectionArr: [35, 53, 70, 87, 105],
    pageBreakArr: [33, 68, 103],
    pageBreakSbmArr: [34, 69, 104],
  },
  자동제어설비: {
    dataStartArr: [45, 62, 79, 96, 114, 132, 150],
    dataInspectionArr: [38, 56, 73, 90, 107, 125, 143],
    pageBreakArr: [36, 71, 105, 141],
    pageBreakSbmArr: [37, 72, 106, 142],
  },
  '방음·방진·내진설비': {
    dataStartArr: [40, 62, 82],
    dataInspectionArr: [33, 51, 73],
    pageBreakArr: [31, 71],
    pageBreakSbmArr: [32, 72],
  }
};
